
import { defineComponent, ref } from "vue";
import { Plus } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { UploadUrl } from "@/utils/request";
import type { UploadProps, UploadUserFile } from "element-plus";
export default defineComponent({
  components: { Plus },
  props: ["imageUrl", "tipText", "changeImg", "uploadSize"],
  setup(props, { emit }) {
    // 图片上传
    const handleAvatarSuccess = (response: void, uploadFile: { raw: string }) => {
      // imageUrl.value = URL.createObjectURL(uploadFile.raw!)
      // emit("update:imageUrl", uploadFile.raw);
      emit("changeImg", response);
      // console.log(uploadFile);
      // console.log(response);
    };
    const beforeAvatarUpload = (rawFile: { type: any; size: number }) => {
      console.log(rawFile.type !== "image/jpeg");
      console.log(rawFile.type);
      if (rawFile.type !== "image/jpeg" && rawFile.type !== "image/png" && rawFile.type !== "image/bmp") {
        ElMessage.error("请上传正确图片格式!");
        return false;
      }

      console.log(rawFile.size / 500 / 500);
      console.log(rawFile.size);

      if (rawFile.size > props.uploadSize * 1000) {
        ElMessage.error(`图片大小不能超过${props.uploadSize / 1000 < 1 ? props.uploadSize + "K" : props.uploadSize / 1000 + "M"}`);
        return false;
      }

      return true;
    };
    const delectImg = () => {
      emit("delectImg", "");
    };
    return { handleAvatarSuccess, beforeAvatarUpload, UploadUrl, delectImg };
  },
});
